// src/hooks/use-internal-translate.ts
import { useTranslate } from "@refinedev/core";
import * as React from "react";
var useInternalTranslate = () => {
  const translate = useTranslate();
  return React.useCallback(
    (key, {
      fallback,
      ns = "common",
      data = {}
    }) => translate(key, { ns, ...data }, fallback),
    [translate]
  );
};

// src/translations/scalingworks.json
var scalingworks_default = {
  pages: {
    list: {
      pageSize: "{{numOfPage}} / page",
      prevPage: "Previous page",
      nextPage: "Next page",
      search: "Search",
      appliedFilter_one: "Applied filter",
      appliedFilter_other: "Applied filters",
      lastUpdatedAt: "Last updated at {{time}}",
      multipleToggle: "Select multiple"
    },
    show: {
      title: "{{title}} details",
      field: "FIELD",
      value: "VALUE",
      image: "Image"
    }
  },
  actions: {
    changeLanguage: "Change language",
    add: "Add",
    getNotification: "Keep me notified of change",
    stopNotification: "Stop notification",
    editSection: "Edit {{section}}",
    clearSelection: "Clear Selection"
  },
  messages: {
    dataMaybeOutdated: "Data may be outdated as we fail to get latest data",
    dataUpdateSuccess: "Data updated successfully",
    deleteResourceConfirmation: "This action is not undoable. Do you want to proceed?",
    noData: "No data",
    noDataWithFilter: "Could not find anything with your search/filter condition",
    uploadedAt: "Uploaded at {{time}}",
    sectionUpdateSuccess: "{{section}} updated successfully"
  }
};

export {
  useInternalTranslate,
  scalingworks_default
};
//# sourceMappingURL=chunk-3NGQI43U.mjs.map